import { ApplicationConfig, importProvidersFrom, Injector, provideZonelessChangeDetection, provideZoneChangeDetection, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { initDatabase } from './services/database.service';
import { environment } from '../environments/environment';
import {provideServiceWorker, ServiceWorkerModule} from '@angular/service-worker';
import { PromptUpdateService } from './services/prompt-update.service';

export const appConfig: ApplicationConfig = {
  providers: [
    // provideZoneChangeDetection({ eventCoalescing: true }), 
    provideServiceWorker('ngsw-worker.js', {
			enabled: environment.hasServiceWorker,
			// Register the ServiceWorker as soon as the application is stable
			// or after 30 seconds (whichever comes first).
			registrationStrategy: 'registerWhenStable:30000'
		}),
    PromptUpdateService,
    CacheStorage,
    provideRouter(routes),

    provideZonelessChangeDetection(),
    provideHttpClient(),
    provideAppInitializer(() => {
        const initializerFn = ((injector: Injector) => () => initDatabase(injector))(inject(Injector));
        return initializerFn();
      })
  ]
};
